<div class="login-bg">
  <div class="modal-header">
    <h4 class="modal-title text-white">Change Password</h4>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
      <span aria-hidden="true" (click)="closeModal()">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
        <form (submit)="handleChangePassword()" [formGroup]="passwordForm">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="text-white" for="currentPassword" [ngClass]="hasError('currentPassword') ? 'text-danger' : ''">Current Password &nbsp; <span class="text-star">*</span></label>
                  <input type="text"  appNotAllowSpaces [ngClass]="hasError('currentPassword') ? 'border-danger' : ''" name="currentPassword"
                    formControlName="currentPassword" class="form-control custom-selectbox" id="currentPassword" placeholder="Enter Current Password" autocomplete="off">
                  <app-show-errors fieldName="Current Password" [showError]="hasError('currentPassword')" [ctrl]="getCtrl('currentPassword')"></app-show-errors>            
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="text-white"  for="newPassword" [ngClass]="hasError('newPassword') ? 'text-danger' : ''">New Password  &nbsp; <span  data-toggle="tooltip" title="{{passwordtext}}" data-placement="bottom"><i class="fas fa-info-circle"></i></span> &nbsp; <span class="text-star">*</span></label>
                  <input type="text" appNotAllowSpaces [(ngModel)]="UserData['password']" (input)="pswdValidate(UserData['password'],'password')" [ngClass]="hasError('newPassword') ? 'border-danger' : ''" name="newPassword"
                    formControlName="newPassword" class="form-control custom-selectbox" id="newPassword" placeholder="Enter New Password" autocomplete="off">
                  <app-show-errors fieldName="New Password" [showError]="hasError('newPassword')" [ctrl]="getCtrl('newPassword')"></app-show-errors>
                  <span style="color:red" [hidden]="!showerrorpwd">Weak Password</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label class="text-white"  for="confirmNewPassword" [ngClass]="hasError('confirmNewPassword') ? 'text-danger' : ''">Confirm New Password &nbsp; <span  data-toggle="tooltip" title="{{passwordtext}}" data-placement="bottom"><i class="fas fa-info-circle"></i></span> &nbsp; <span class="text-star">*</span></label>
                  <input type="text" appNotAllowSpaces [(ngModel)]="UserData['confirmpassword']" (input)="pswdValidate(UserData['confirmpassword'],'confirm')" [ngClass]="hasError('confirmNewPassword') ? 'border-danger' : ''" name="confirmNewPassword"
                    formControlName="confirmNewPassword" class="form-control custom-selectbox" id="confirmNewPassword" placeholder="Enter New Password Again" autocomplete="off">
                  <app-show-errors fieldName="Confirm New Password" [showError]="hasError('confirmNewPassword')" [ctrl]="getCtrl('confirmNewPassword')"></app-show-errors>
                  <span style="color:red" [hidden]="!showerrorcnpwd">Weak Password</span>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group text-center mb-0">
                <!-- <label for="Submit" class="col-sm-4 col-form-label"></label> -->
                  <input type="submit" class="btn btn-info" [disabled]="!this.passwordForm.valid || showerrorcnpwd || showerrorpwd" value="{{context}} Password">
              </div>
            </div>
          </div>
        </form>
  </div>
  </div>
  